import React from "react";
import { connect } from "react-redux";
import { authLogout } from "../../system/store/auth/actions";

import "./Sidebar.css";

import SideBarHeader from "./Header";
import SideBarFooter from "./Footer";
import SideBarMenu from "./Menu";

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.logout = this.logout.bind(this);
  }

  logout() {
    this.props.dispatch(authLogout());
  }

  render() {
    const { currentUser, isLoading, sidebarVisible } = this.props;
    if (isLoading) {
      return <aside className="sidebar sidebar--main" />;
    } else {
      return (
        <aside
          className={
            sidebarVisible
              ? "sidebar sidebar--main is-visible"
              : "sidebar sidebar--main"
          }
        >
          <SideBarHeader currentUser={currentUser} logout={this.logout} />
          <SideBarMenu />
          <SideBarFooter />
        </aside>
      );
    }
  }
}

function mapStateToProps(store) {
  return {
    isAuthenticated: store.auth.isAuthenticated,
    currentUser: store.auth.currentUser,
    isLoading: store.auth.isLoading,
    sidebarVisible: store.site.sidebarVisible
  };
}

export default connect(mapStateToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.jsx